const mediaQuery = (triggerWidth: number): string =>
  `@media (max-width: ${triggerWidth}px)`;

export default mediaQuery;
